import React from "react";
import { useSelector } from "react-redux";
import { IThread } from "../interfaces/App";
import { IApplicationState } from "../stores/AppStore";

interface IProps {
    onChange: (idx: number) => void;
    currentThread: number;
}
function ThreadList(props: IProps) {
    const app = useSelector((appState: IApplicationState) => appState.app);
   
    const renderThread = (thread: IThread, idx: number) => {
        return (
            <li 
                key={"thread_" + thread.threadId}
                onClick={() => props.onChange(idx)}
                className={`${props.currentThread === idx ? "active" : ""}`}
            >
                {thread.name}
            </li>
        );
    };

    return app.threads ?
    (
        <div className="threadList">
            <ul>
                {app.threads.map(renderThread)}
            </ul>
        </div>
    ) : (null);
}
export default (ThreadList);
